// extracted by mini-css-extract-plugin
module.exports = {"save":"index_save_2_2GM","cancel":"index_cancel_3JoD_","display":"index_display_PA_s6","leveldiv":"index_leveldiv_XvgpV","totaldiv":"index_totaldiv_Zq_6o"};